module.exports = " <div class=difficulties _v-6ff4fb52=\"\"> <template v-for=\"difficulty in sortedDifficulties\"> <div class=difficulty _v-6ff4fb52=\"\"> <h3 _v-6ff4fb52=\"\">{{difficulty.name}}</h3> <div class=meter :class=getMeterClasses(difficulty) _v-6ff4fb52=\"\"> <div class=progress _v-6ff4fb52=\"\"></div> </div> </div> </template> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-6ff4fb52!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Difficulties.vue
// module id = 756
// module chunks = 2